import { perform } from "./tasks.service.helper";
import { testbuyServiceBaseUrl } from "@coworker/app/src/core/cloud-services/cloud-services.helper";
import { isChineseEnvironment } from "@coworker/reusable/helpers/devices";
import { getEnvironmentId } from "@coworker/reusable/helpers/environment";
import { makeServiceHeaders } from "../../core/hooks/fetch.helpers";

const isChina = isChineseEnvironment();

const TESTBUY_SERVICE_URL = testbuyServiceBaseUrl(getEnvironmentId(), isChina);

/***
 * @returns A promise which resolves when the request is done.
 * If you care about results then use the callback.
 */

export async function postToTestbuyService(
  path,
  bodyData,
  callback,
  responseType
) {
  const url = `${TESTBUY_SERVICE_URL}/${path}`;
  await perform("POST", url, bodyData, callback, responseType);
}

// TODO: fetchAPI should replace perform eventually that is after global rollout which removes the firebase functions
export async function fetchAPI(path, method, body) {
  const url = `${TESTBUY_SERVICE_URL}/${path}`;
  const options = {
    method,
    headers: await makeServiceHeaders(),
  };

  if (method !== "GET") options.body = JSON.stringify(body);

  const response = await fetch(url, options);

  if (!response.ok) {
    throw new Error("Response was not ok.");
  }

  const text = await response.text();
  return JSON.parse(text);
}
